import React from "react"

import PoliticalDetail from "./PoliticalDetail";

const PoliticalPreviewComp = (props)=>{

    let statusClass = "panel-status";
    if (props.config && props.config.status && props.config.status.state) {
        statusClass = `${statusClass} ${props.config.status.state}`;
    }

    return(
        <div className="panel">

            <div className="panel-header">
                <div className="panel-header-label">{props.config.title}</div>
            </div>

            <PoliticalDetail data={props.data} mode="PREVIEW"/>
            
            <div className="panel-footer">
                <div className={statusClass}>{props.config.status.message}</div>
                <div className="btn-group">
                    <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={props.config.btnCancel.handler}>{props.config.btnCancel.label}</button>
                    {(props.config.editorMode === "NEW" || (props.config.editorMode === "UPDATE" &&  props.config.detailMode==="PREVIEW")) && 
                        <button id="btnSave" type="button" className="btn btn-primary" onClick={props.btnOk.handler}>{props.config.btnOk.label}</button>
                    }
                </div>
            </div>

        </div>
    );

};

export default PoliticalPreviewComp;